import React from 'react';
import { Stack, Typography } from '@mui/material';
import styles from '../../assets/css/components/MobileRoomBar.module.css';

interface MobileRoomBarProps {
    userConnectedCount: number;
}

const MobileRoomBar: React.FC<MobileRoomBarProps> = ({ userConnectedCount }) => {
    const playersOnline = new Intl.NumberFormat().format(userConnectedCount);

    return (
        <Stack direction="row" spacing={3} className={styles.mobileRoomBar} sx={{ overflowX: 'auto' }}>
            <Stack direction="row" spacing={2} alignItems="center">
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <Typography className={styles.playerCount} component="p" variant="body1">{playersOnline}<span className={styles.dot}></span><span style={{ color: '#3de361'}}>ON</span></Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default MobileRoomBar;